/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/** 用户相关：用户信息等 */
import { http } from '@/services/api/http';
import { RequestOptions } from '@/services/api/types';
import type * as model from './models';

/** 用户相关：用户信息等 查询用户配置 */
export async function profileGetPost(options?: RequestOptions) {
  const result = await http.request<model.IApiJsonResultUserProfileResp>({
    url: `/es/api/biz/user/profile/get`,
    method: 'post',
    ...options,
  });

  return result.data;
}

/** 用户相关：用户信息等 更新或保存用户配置 */
export async function savePost(payload: model.IApiUserProfileReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultboolean>({
    url: `/es/api/biz/user/profile/save`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}
